export default "__VITE_ASSET__Bn2h6J0G__"